import type { AxiosError } from 'axios';

import { state } from '../plugin';

async function onRejected(error: AxiosError) {
  if (error.response?.status && state.onErrorClb[error.response.status]) {
    const clb = state.onErrorClb[error.response.status];

    if (clb) {
      clb(error);
    }
  }

  return Promise.reject(error);
}

export const responseInterceptor = {
  onFulfilled: undefined,
  onRejected,
};
